(function () {
  'use strict';

  var initialized = new WeakSet();

  function setAngle(root, active) {
    var toggle = root.querySelector('[data-okdo-media-toggle]');
    var label = root.querySelector('[data-okdo-media-toggle-label]');
    root.classList.toggle('is-angle-view', active);
    if (toggle) toggle.setAttribute('aria-pressed', String(active));
    if (label) label.textContent = active ? 'Banner View' : '15° View';
  }

  function resetSiblings(root) {
    document.querySelectorAll('[data-okdo-media-switch].is-angle-view').forEach(function (candidate) {
      if (candidate !== root) setAngle(candidate, false);
    });
  }

  function boot(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    var toggle = root.querySelector('[data-okdo-media-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var active = toggle.getAttribute('aria-pressed') !== 'true';
      if (active) resetSiblings(root);
      setAngle(root, active);
      if (active && window.okdoTrack) {
        window.okdoTrack('okdo_product_banner_reveal', { view: 'white-background-15-degree' });
      }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      setAngle(root, false);
      var activeElement = document.activeElement;
      if (activeElement && root.contains(activeElement) && activeElement.blur) activeElement.blur();
      else if (root.blur) root.blur();
    });
    root.addEventListener('okdo:media-reset', function () { setAngle(root, false); });
  }

  function init(scope) {
    scope.querySelectorAll('[data-okdo-media-switch]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-okdo-media-switch].is-angle-view').forEach(function (root) {
      if (!root.contains(event.target)) setAngle(root, false);
    });
  });
})();
